const MarketplaceOrderDetailsPage = (): JSX.Element => {
    return (
      <>MarketPlace Order Details</>
    )
  }
  
  export default MarketplaceOrderDetailsPage